// @ts-strict-ignore
import { LIQUID_THEME } from "@components/MonacoHtmlEditor/config/constants";

export const setupMonarchTokensProvider = ({
  monaco,
  liquidThemeConfig,
  getLanguageSettings,
  language,
  insertionWithOptions,
}) => {
  monaco.editor.defineTheme(LIQUID_THEME, liquidThemeConfig);
  const { tokenProvider } = getLanguageSettings(language, insertionWithOptions);

  monaco.languages.setMonarchTokensProvider(language, {
    ...tokenProvider,
  });
};
